import styled, { css } from 'styled-components';

interface Props {
  color?: 'gray' | 'white';
  bordered?: boolean;
}

export const Card = styled.div<{ $bgColor; $color; $bordered }>`
  display: flex;
  align-items: center;
`;

export default styled.div<Props>`
  ${({ theme: { space, boxShadow, color }, color: bgColor, bordered }) => css`
    background: ${bgColor === 'gray' ? '#EBEBEB' : color.white};
    ${!bordered ? 'box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);' : ''}
    border-radius: 10px;
    ${bordered ? 'border: 1px solid #DBDFEF;' : ''}
    flex: 1;

    .card {
      &__head {
        margin-bottom: ${space.sm};
      }
    }

    &.medium {
      padding: ${space.md};
    }

    &.small {
      padding: ${space.sm};
    }

    &.large {
      padding: ${space.xxxl} 6em;
    }

    &.low {
      box-shadow: ${bordered ? 'none' : boxShadow.sm};
    }

    &.normal {
      box-shadow: ${bordered ? 'none' : boxShadow.md};
    }

    &.high {
      box-shadow: ${bordered ? 'none' : boxShadow.md};
    }
  `}
`;
